var _defs, _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafficRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 3px;\n        stroke: #04C0C2;\n        fill-rule: evenodd;\n      }\n      .cls-2 {\n        ", "\n        stroke-width: 3px;\n        stroke: #04C0C2;\n        fill-rule: evenodd;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_1",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 1",
    className: "cls-1",
    x: 14.125,
    y: 0,
    width: 36,
    height: 64,
    rx: 12,
    ry: 12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_2-2",
    "data-name": "\\u692D\\u5706 1",
    className: "cls-2",
    cx: 31.688,
    cy: 11.844,
    r: 6.688
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_2-3",
    "data-name": "\\u692D\\u5706 2",
    className: "cls-2",
    cx: 31.688,
    cy: 31.844,
    r: 6.688
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_2-3",
    "data-name": "\\u692D\\u5706 3",
    className: "cls-2",
    cx: 31.688,
    cy: 51.844,
    r: 6.688
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficRightIcon);
export default __webpack_public_path__ + "static/media/traffic-right-icon.7298d0171b7913fbede74f06b93e5e17.svg";
export { ForwardRef as ReactComponent };